<template>
  <div class="expressionbox">
    <van-swipe class="my-swipe" ref="uploadswip" indicator-color="white" :loop="false" @change="emjoytabClick">
      <van-swipe-item v-for="item in emjoylist" :key="item.id">
        <div class="expression_listbox">
          <div class="expression_list" v-for="item in item.list" :key="item.id" @click="emjoyClickButton(item)">
            <img class="expression_list_img" :src="item.src" />
            <div class="expression_list_name">{{ item.name }}</div>
            <div class="expression_list_gif" v-show="expressionTip.id == item.id">
              <img class="" :src="expressionTip.gifSrc" />
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="expression_tab">
      <div class="expression_tablistbox">
        <div class="expression_tablist" v-for="item in emjoytab" :key="item.id"
          :class="item.id == curemjoy ? 'expression_tablistcur' : ''" @click="emjoytabClick(item.id)">
          <img :src="item.src" />
        </div>
      </div>
      <!-- <div
        class="expression_tab_delete"
        @click="deleteClick"
      ></div> -->
    </div>
    <div class="close" @click="close"></div>
  </div>
</template>
<script>
import emjoydata from "../../../utils/emjoydata";
export default {
  name: "emjoy",
  data() {
    return {
      emjoylist: [],
      emjoytab: [],
      expressionTip: {},
      curemjoy: 0, //当前表情包索引
    };
  },
  mounted() {
    switch (this.$store.state.gameType) {
      case 1://龙之国
        this.emjoylist = emjoydata.emjoylist;
        this.emjoytab = emjoydata.emjoytab;
        break;
      case 2://钢岚
        this.emjoylist = emjoydata.glEmjoylist;
        this.emjoytab = emjoydata.glEmjoytab;
        break;
      case 3://第七史诗
        this.emjoylist = emjoydata.dqssEmjoylist;
        this.emjoytab = emjoydata.dqssEmjoytab;
        break;
      default:
        break;
    }
  },
  methods: {
    deleteClick() {
      this.$emit("deleteClick");
    },
    emjoytabClick(id) {
      //表情包tab点击
      this.curemjoy = id;
      console.log(id);
      this.$refs.uploadswip.swipeTo(id);
    },  
    emjoyClickButton(item) {
      this.$emit("pushvalue", item);
    },
    close() {
      this.$emit("closeEmo");

    },
  },
};
</script>

<style lang="scss" scoped>
.expressionbox {
  padding: .5rem .5rem .3rem .5rem;
  overflow: hidden;
  width: 7.53rem;
  height: 7rem;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  top: 0;
}

.expression_listbox {
  height: 6rem;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  width: .46rem;
  height: .46rem;
  background: url(../../../assets/img/point/icon_close.png);
  background-size: 100% 100%;
}
</style>